import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Typography, Box, Grid } from '@mui/material';

export const HeaderFreight = () => {
  const { itemTruckingSelected } = useSelector((state) => state.customerQuotes);

  const ARRAY_HEADER = [
    {
      title: 'Địa điểm đi:',
      value: itemTruckingSelected?.objLocationFrom?.name,
      xs: 3,
    },
    {
      title: 'Khu vực đi:',
      value: itemTruckingSelected?.objAreaFrom?.name,
      xs: 3,
    },
    {
      title: 'Địa điểm đến:',
      value: itemTruckingSelected?.objLocationTo?.name,
      xs: 3,
    },
    {
      title: 'Khu vực đến:',
      value: itemTruckingSelected?.objAreaTo?.name,
      xs: 3,
    },
  ];

  return (
    <>
      <ContainerItemService>
        <b>
          {itemTruckingSelected?.serviceName} - {itemTruckingSelected?.subServiceName}
        </b>
      </ContainerItemService>
      <Box sx={{ padding: '10px 20px 10px 20px', fontSize: '14px' }}>
        <Grid container spacing={3}>
          {ARRAY_HEADER.map((item, index) => (
            <Grid item xs={item?.xs} key={`${item?.title}-${index}`}>
              <Typography component="b" variant="string">
                {item?.title}
              </Typography>
              <Typography component="div" variant="string" sx={{ color: 'blue' }}>
                {item?.value}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export const ContainerItemService = styled(Box)(({ theme }) => ({
  height: 'fit-content',
  backgroundColor: 'rgba(6, 95, 212, 0.1)',
  borderRadius: '12px',
  display: 'flex',
  marginBottom: '10px',
  marginTop: '5px',
  padding: '10px 20px',
}));
